import React from 'react';

const AccessibilitySkip = () => {

    return (
        <div className={'ch-accessibility-skip'} tabIndex={-1}>
            <a href="#contentPanel" tabIndex={0}>Skip to content</a>
        </div>
    );
};

export default AccessibilitySkip;